import { toEnDigit } from "./convertDigit";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function toRightPhoneNumber(number: any): string {
  if (!number) return "";

  let result = toEnDigit(number)
    .replace(/\+/g, "")
    .replace(/ /g, "")
    .replace(/\(/g, "")
    .replace(/\)/g, "")
    .replace(/-/g, "")
    .trim();

  result = `0${result.substring(result.length - 10)}`;
  return result;
}
